@import '../scss/tokens';

:host {
  display: block;
  height: 100%;
  width: auto;
  border-radius: #{map-get($tokens, sy-blog-related-posts-card-border-radius)};
  background-color: #{map-get($tokens, sy-blog-related-posts-card-background-color)};
  box-shadow: #{map-get($tokens, sy-blog-related-posts-card-box-shadow)};

  &:hover {
    background-color: #{map-get($tokens, sy-blog-related-posts-card-hover-background-color)};
  }

  a {
    display: block;
    color: unset;
    width: 100%;
    height: 100%;
    text-decoration: unset;

    div {
      width: auto;
      height: 100%;
      box-sizing: border-box;
    }

    #horizontal-container {
      display: flex;
      flex-direction: row;
      height: 100%;
      gap: 16px;

      #vertical-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        width: calc(100% - #{map-get($tokens, sy-blog-related-posts-card-img-basis)});

        #content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          max-height: 100%;
          color: #{map-get($tokens, sy-blog-related-posts-card-title-color)};

          --sy-heading-h5-font-weight: #{map-get($tokens, sy-blog-related-posts-card-title-font-weight)};
          --sy-heading-h5-font-size: #{map-get($tokens, sy-blog-related-posts-card-title-font-size)};

          .category {
            margin-bottom: #{map-get($tokens, sy-blog-related-posts-card-category-margin-bottom)};
            color: #{map-get($tokens, sy-blog-related-posts-card-category-color)};

            --sy-heading-h4-font-weight: #{map-get($tokens, sy-blog-related-posts-card-category-font-weight)};
            --sy-heading-h4-font-size: #{map-get($tokens, sy-blog-related-posts-card-category-font-size)};
          }
        }

        sy-card-footer {
          color: #{map-get($tokens, sy-blog-related-posts-card-date-color)};

          --sy-content-regular-small-font-weight: #{map-get($tokens, sy-blog-related-posts-card-date-font-weight)};
          --sy-content-regular-small-font-size: #{map-get($tokens, sy-blog-related-posts-card-date-font-size)};
        }
      }

      #img-container {
        width: #{map-get($tokens, sy-blog-related-posts-card-img-basis)};
        flex-grow: 0;
        flex-shrink: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        slot[name='img'] {
          max-width: 100%;
        }
      }
    }
  }
}
